var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group row mt-3" },
    [
      _c("plain-text-control", {
        staticClass: "col-xs-12 col-sm-5 col-form-label",
        attrs: {
          title: _vm.$attrs.title,
          instructionKey: _vm.$attrs.instructionsKey,
          required: _vm.$attrs.required,
          id: _vm.$attrs.title
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-row-content" },
        [
          _c("label-control", {
            staticClass: "col-12 col-sm-3 col-form-label",
            attrs: {
              title: "BudgetaryEstimate.Delegation.MinText",
              forElement: "sumMin"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-5 col-sm-2 col-xl-1 form-row-content" },
        [
          _c("numeric-input-control", {
            staticClass: "form-control",
            attrs: {
              name: "DelegatedAid.SumMin",
              id: "sumMin",
              required: _vm.$attrs.required,
              disabled: _vm.$attrs.disabled,
              placeholderKey: "BudgetaryEstimate.Delegation.MinText",
              maxValue: _vm.getMax,
              "aria-label": _vm.minAriaLabelText
            },
            model: {
              value: _vm.delegatedAid.sumMin,
              callback: function($$v) {
                _vm.$set(_vm.delegatedAid, "sumMin", _vm._n($$v))
              },
              expression: "delegatedAid.sumMin"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "min-max-hyphen" }, [_vm._v("-")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-row-content" },
        [
          _c("label-control", {
            staticClass: "col-12 col-sm-3 col-form-label",
            attrs: {
              title: "BudgetaryEstimate.Delegation.MaxText",
              forElement: "sumMax"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-5 col-sm-2 col-xl-1 form-row-content" },
        [
          _c("numeric-input-control", {
            staticClass: "form-control",
            attrs: {
              name: "DelegatedAid.SumMax",
              id: "sumMax",
              required: _vm.$attrs.required,
              disabled: _vm.$attrs.disabled,
              placeholderKey: "BudgetaryEstimate.Delegation.MaxText",
              minValue: _vm.getMin,
              "aria-label": _vm.maxAriaLabelText
            },
            model: {
              value: _vm.delegatedAid.sumMax,
              callback: function($$v) {
                _vm.$set(_vm.delegatedAid, "sumMax", _vm._n($$v))
              },
              expression: "delegatedAid.sumMax"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }